import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Tooltip as Tooltip$1 } from '@mui/material';
import { useTooltip } from './useTooltip.js';

function Tooltip(_a) {
    var { showOnlyOnEllipsis, lineClamp, fallbackPlacements } = _a, props = __rest(_a, ["showOnlyOnEllipsis", "lineClamp", "fallbackPlacements"]);
    const { popperProps, shouldDisableTooltip, handleRef } = useTooltip({
        showOnlyOnEllipsis,
        fallbackPlacements,
        lineClamp,
    });
    return (jsx(EllipsisTooltip, Object.assign({ "$lineClamp": lineClamp, "$showOnlyOnEllipsis": showOnlyOnEllipsis, PopperProps: popperProps, disableFocusListener: shouldDisableTooltip, disableHoverListener: shouldDisableTooltip, disableTouchListener: shouldDisableTooltip, ref: handleRef }, props)));
}
const EllipsisTooltip = styled(Tooltip$1)(({ $showOnlyOnEllipsis, $lineClamp }) => {
    if (!$showOnlyOnEllipsis) {
        return {};
    }
    if ($lineClamp === undefined || $lineClamp === 1) {
        return {
            display: "block",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        };
    }
    return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkit-line-clamp": `${$lineClamp}`,
        "-webkit-box-orient": "vertical",
        overflowWrap: "anywhere",
    };
});

export { Tooltip };
//# sourceMappingURL=Tooltip.js.map
